import React from "react";
import { formatPhoneNumber } from "../../utils/phoneUtils";

const FORMAT_OPTIONS = [
  { id: "text", label: "Text" },
  { id: "phone", label: "Phone" },
];

const LineInputWithFormat = ({
  label,
  value,
  onChange,
  format = "text",
  onFormatChange,
  placeholder,
  maxLength = 25,
  required = false,
  inputClassName = "",
}) => {
  const handleChange = (e) => {
    const next = format === "phone" ? formatPhoneNumber(e.target.value) : e.target.value;
    onChange(next);
  };

  return (
    <div>
      <div className="flex items-center justify-between gap-3 mb-2">
        <label className="block text-sm font-medium text-light-text dark:text-dark-text">
          {label}
        </label>
        <div
          className="inline-flex rounded-lg border border-light-border dark:border-dark-border overflow-hidden shrink-0"
          role="group"
          aria-label={`${label} format`}
        >
          {FORMAT_OPTIONS.map((option) => (
            <button
              key={option.id}
              type="button"
              onClick={() => onFormatChange(option.id)}
              className={`px-2.5 py-1 text-xs font-semibold transition-colors ${
                format === option.id
                  ? "bg-btn-primary dark:bg-btn-primary-dark text-white"
                  : "bg-white dark:bg-dark-surfaceLight text-light-textMuted dark:text-dark-textMuted hover:bg-light-surface dark:hover:bg-dark-surfaceHover"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
      <input
        type={format === "phone" ? "tel" : "text"}
        value={value}
        onChange={handleChange}
        placeholder={format === "phone" ? "(555) 123-4567" : placeholder}
        maxLength={maxLength}
        required={required}
        className={
          inputClassName ||
          "w-full px-4 py-2.5 text-sm bg-white dark:bg-dark-surfaceLight border-2 border-light-border dark:border-dark-border text-light-text dark:text-dark-text rounded-lg focus:ring-2 focus:ring-light-primary dark:focus:ring-dark-primary focus:border-light-primary dark:focus:border-dark-primary transition-all"
        }
      />
    </div>
  );
};

export default LineInputWithFormat;
